import { ReqAlarms } from '../models/alarm.model';

/**
 * Alarm 관련 Query Keys
 *
 * @description
 * Alarm 관련 query-key들을 관리합니다.
 */
export const alarmKeys = {
  /** ALL */
  ALARM_ALL: ['alarm'],

  /** 알람 리스트 조회 */
  FETCH_ALARMS: (query: ReqAlarms) => ['alarm', 'fetchAlarms', JSON.stringify(query)],

  /** 읽지 않은 알람 카운트 */
  FETCH_UNREAD_ALARM_COUNT: () => ['alarm', 'fetchUnreadAlarmCount'],

  /** 알람 읽음 처리 */
  CREATE_ALARM_READED: () => ['alarm', 'createAlarmReaded']
};
